import { jsx as _jsx } from "react/jsx-runtime";
import { lazy } from 'react';
var SettingsPage = lazy(function () { return import('@/modules/mobility-console/pages/settings'); });
var DashboardPage = lazy(function () { return import('@/modules/mobility-console/pages/dashboard'); });
var KnowledgeBaseManagePage = lazy(function () { return import('@/modules/mobility-console/pages/knowledgeBaseManage'); });
export var MobilityConsoleRoutes = [
    {
        path: '/',
        element: _jsx(DashboardPage, {}),
    },
    {
        path: '/settings',
        element: _jsx(SettingsPage, {}),
    },
    {
        path: '/knowledge-base',
        element: _jsx(KnowledgeBaseManagePage, {}),
    },
];
